import api from '../../../services/Api';
import { IAuditoriaPddAnaliticaResultado } from '../interfaces/IAuditoriaPddAnalitica';

export const AuditoriaPddAnaliticaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaPddAnaliticaResultado> {
    const response = await api.get<IAuditoriaPddAnaliticaResultado>('auditoria-pdd-analitica/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        saldosPendentes: [],
        saldosConciliados: [],
      }
    );
  },
};
